export default __webpack_public_path__ + "static/media/radiant-bright-purple-orange.bc3829e7.jpg";